import styled from "styled-components";

export default styled.div`
  background-color: ${props => props.muiTheme.palette.primary.main};
  min-height: 4px;
`;
